import type { U3130HonorariumItem } from '../U3130TimesheetModel';

/** Codes natures du projet (ex. `CAD+CL+IMP`, ordre MyEvent) — vide si absent. */
export function u3130ProjectWorkNatureFromRow(row: U3130HonorariumItem | null | undefined): string {
  return row?.project?.workNatureDisplay?.trim() ?? '';
}

/** Descriptions natures de la tâche selon la langue UI, repli sur l’autre langue — vide si absent. */
export function u3130TaskWorkNatureDescriptionForLanguage(
  row: U3130HonorariumItem | null | undefined,
  language: string,
): string {
  const fr = row?.task?.workNatureDescriptionFr?.trim() ?? '';
  const en = row?.task?.workNatureDescriptionEn?.trim() ?? '';
  if ((language ?? '').toLowerCase().startsWith('en')) {
    return en || fr;
  }
  return fr || en;
}
